import * as React from 'react';

import { Tag } from '@cian/components';

import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IDomrfTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const DomrfTagItem = (props: IDomrfTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Аренда от ДОМ.РФ
    </TagComponent>
  );
};
